import Vue from 'vue'
import Router from 'vue-router'
import Homepage from '@/components/Homepage'
import Transactions from '@/components/Transactions'
import Leaderboard from '@/components/Leaderboard'
import Break from '@/components/Break'
import Drop from '@/components/Drop'
import Circles from '@/components/Circles'
import About from '@/components/About'
import Menu from '@/components/Menu'
import Plots from '@/components/Plots'
import Spaces from '@/components/Spaces'
import Demo from '@/components/Demo'
import Terms from '@/components/Terms'
import Privacy from '@/components/Privacy'
import Subscribe from '@/components/Subscribe'
import Tang from '@/components/Tang'
import Dob from '@/components/Dob'
import Preme from '@/components/Preme'
import Zora from '@/components/Zora'
import Plot from '@/components/Plot'
import Agents from '@/components/Agents'

Vue.use(Router);

const router = new Router({
  mode: 'history', // routes without the hash
  routes: [
    {
      path: '/',
      name: 'homepage',
      component: Homepage,
      meta: {
        title: 'Million Bit Homepage'
      }
    },
    {
      path: '/list',
      name: 'list',
      component: Transactions,
      meta: {
        title: 'Million Bit List'
      }
    },
    {
      path: '/leaderboard',
      name: 'leaderboard',
      component: Leaderboard,
      meta: {
        title: 'Million Bit Leaderboard'
      }
    },
    {
      path: '/break',
      name: 'break',
      component: Break,
      meta: {
        title: 'Million Bit Break'
      }
    },
    {
      path: '/drop',
      name: 'drop',
      component: Drop,
      meta: {
        title: 'Million Bit Drop'
      }
    },
    {
      path: '/about',
      name: 'about',
      component: About,
      meta: {
        title: 'About the Million Bit Homepage'
      }
    },
    {
      path: '/menu',
      name: 'nav-menu',
      component: Menu,
      meta: {
        title: 'Million Bit Menu'
      }
    },
    {
      path: '/demo',
      name: 'nav-demo',
      component: Demo,
      meta: {
        title: 'Million Bit Homepage Demo'
      }
    },
    {
      path: '/plots',
      name: 'plots',
      component: Plots,
      meta: {
        title: 'Million Bit Homepage Plots'
      }
    },
    {
      path: '/spaces',
      name: 'spaces',
      component: Spaces,
      meta: {
        title: 'Based Spaces',
      }
    },
    {
      path: '/terms',
      name: 'terms',
      component: Terms,
      meta: {
        title: 'Million Bit Homepage - Terms of Service',
      }
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: Privacy,
      meta: {
        title: 'Million Bit Homepage - Privacy Policy',
      }
    },
    {
      path: '/subscribe',
      name: 'subscribe',
      component: Subscribe,
      meta: {
        title: 'Subscribe to the Million Bit Homepage',
      }
    },
    {
      path: '/tang',
      name: 'tang',
      component: Tang,
      meta: {
        title: 'Tang Tree powered by the Million Bit Homepage',
      }
    },
    {
      path: '/dob',
      name: 'dob',
      component: Dob,
      meta: {
        title: 'DOB Pixel Gallery powered by the Million Bit Homepage',
      }
    },
    {
      path: '/preme',
      name: 'preme',
      component: Preme,
      meta: {
        title: 'Preme Bit Page powered by the Million Bit Homepage',
      }
    },
    {
      path: '/zora',
      name: 'zora',
      component: Zora,
      meta: {
        title: 'Million Zora Post powered by the Million Bit Homepage',
      }
    },
    {
      path: '/circles',
      name: 'circles',
      component: Circles,
      meta: {
        title: 'Million Circles',
      }
    },
    {
      path: '/plot/:id',
      name: 'plot',
      component: Plot,
      meta: {
        title: 'Plot Details - Million Bit Homepage'
      }
    },
    {
      path: '/agents',
      name: 'agents',
      component: Agents,
      meta: {
        title: 'Agents - Million Bit Homepage',
      }
    },
    {
      path: '*', // Catch-all for undefined paths in the new mode
      redirect: '/', // Redirect to home or any other default route
    },
  ]
});

router.beforeEach((to, from, next) => {
  // Access the title from the route's meta field
  if (to.meta && to.meta.title) {
    document.title = to.meta.title;
  } else {
    document.title = 'Million Bit Homepage'; // Fallback title
  }
  next(); // Proceed to the route
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js